// extracted by mini-css-extract-plugin
module.exports = {"risk-tips-wrapper":"index-module_risk-tips-wrapper_R_a96","brand-badge":"index-module_brand-badge_8u2ou","recharge-brand-badge":"index-module_recharge-brand-badge_3_4l_"};